module.exports = __webpack_public_path__ + "static/media/comments-dollar.7691a545.svg";